import type { GetCourseDetail200AiFeedback } from './getCourseDetail200AiFeedback';
import type { GetCourseDetail200LocalizedSectionsItem } from './getCourseDetail200LocalizedSectionsItem';
import type { GetCourseDetail200SectionsItem } from './getCourseDetail200SectionsItem';
import type { GetCourseDetail200Summary } from './getCourseDetail200Summary';
import type { GetCourseDetail200TranslationsItem } from './getCourseDetail200TranslationsItem';

export type GetCourseDetail200 = {
  /**
   * 사용자별 수강 등록에 대한 코스 종합 AI 피드백 (수강생이고 피드백 존재 시 반환)
   * @nullable
   */
  aiFeedback?: GetCourseDetail200AiFeedback;
  /** 강의 상세 설명 */
  description: string;
  /** 언어별 커리큘럼 구성 정보 */
  localizedSections?: GetCourseDetail200LocalizedSectionsItem[];
  sections: GetCourseDetail200SectionsItem[];
  /** 강의 요약 정보 */
  summary: GetCourseDetail200Summary;
  /** 언어별 강의 제목 및 설명 번역 */
  translations?: GetCourseDetail200TranslationsItem[];
};
